<template>
  <v-data-table
    :headers="headers"
    :items="results.results"
    :options.sync="options"
    :server-items-length="results.count"
    v-if="results"
    :loading="isLoading"
    :footer-props="{itemsPerPageOptions: [5, 25, 50, 100]}"
    @update:options="options = options"
  >
    <template v-slot:item.id="{ item }">
      <router-link :to="{name: `${routerNamespace}.detail`, params: {id: item.id}}">
        {{ item.id }}
      </router-link>
    </template>
    <template v-slot:item.client.name="{ item }">
      <router-link :to="{name: `communities.detail`, params: {id: item.group.client.id}}">
        {{ item.group.client.name }}
      </router-link>
    </template>
    <template v-slot:item.license_id="{ item }">
      <span class="monospace">{{ item.license_id }}</span>
    </template>
    <template v-slot:item.valid="{ item }">
      <v-simple-checkbox
        v-model="item.valid"
        disabled
      ></v-simple-checkbox>
    </template>
    <template v-slot:top>
      <data-table-top
        :form-title="formTitle"
        :item="editedItem"
        :entity-name="entityName"
        :entity-name-plural="entityNamePlural"
        :can-create="canCreate"
        :can-edit="canEdit"
        :query.sync="filters.q"
        @save="save($event)"
        @close="close()"
        ref="top"
      >
        <template v-slot:modalForm="slotProps">
          <v-row>
            <v-col
              cols="6"
            >
              <autocomplete-select
                apiPath="admin/groups"
                textField="name"
                :multiple="false"
                :readonly="slotProps.item.id != null"
                :filters="{client: createData.client}"
                v-model="slotProps.item.group"
                label="Group"
                :error-messages="itemErrors.fieldErrors.group || []"
              ></autocomplete-select>
            </v-col>
            <v-col
              cols="6"
            >
              <v-checkbox
                v-model="slotProps.item.valid"
                autofocus
                label="Valid"
                :error-messages="itemErrors.fieldErrors.valid || []"
              ></v-checkbox>
            </v-col>
          </v-row>
        </template>
      </data-table-top>
    </template>
    <template v-slot:item.actions="{ item }" v-if="canEdit(item) || canDestroy(item)">
      <v-icon
        small
        v-if="canEdit"
        class="mr-2"
        @click="editItem(item)"
      >
        {{ $icons.mdiPencil }}
      </v-icon>
    </template>
  </v-data-table>
</template>

<script>
import AutocompleteSelect from '@/components/AutocompleteSelect'
import DataTable from './DataTable'

export default {
  mixins: [DataTable],
  components: {
    AutocompleteSelect
  }

}
</script>